import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import { phoneNumberValidator } from '~/core/validators/phone-number.validator';
import { ParamethorNameEnum } from '~/paramethor/names.enum';
import { ParamethorService } from '~/paramethor/paramethor.service';

@Injectable({
  providedIn: 'root',
})
export class ValidatorsService {
  private readonly _defaultPattern = '.*';

  constructor(private readonly paramethorService: ParamethorService) {}

  public phoneNumber(localFormat: string): Validators[] {
    if (
      this.paramethorService.get(ParamethorNameEnum.ValidatorPhoneNumber)
    ) {
      return [phoneNumberValidator(localFormat)];
    }
    return [];
  }

  public postalCode(): Validators[] {
    if (
      this.paramethorService.isTrue(
        ParamethorNameEnum.ValidatorPostalCode
      )
    ) {
      return [
        Validators.pattern(
          this.paramethorService.get(
            ParamethorNameEnum.ValidatorPostalCode,
            this._defaultPattern
          )
        ),
      ];
    }
    return [];
  }
}
